import type { GameState, Reason } from '@brig/rules-engine';
import type { TFunction } from 'i18next';
import type { HistoryError } from './history.ts';

/** Placeholder values some explanations need, from the game's ruleset. */
function params(state: GameState, reason: Reason): Record<string, number> {
  if (reason === 'volleyTooFewShooters') return { n: state.ruleset.volleyMinShooters };
  if (reason === 'wrongCrewSize') return { n: state.ruleset.fortRepairCrew };
  return {};
}

/**
 * A player-facing sentence for why an action is not allowed (docs/ux.md U-WHY-01..03): keyed
 * on the engine's reason, never its developer message.
 */
export function whyText(t: TFunction, state: GameState, reason: Reason): string {
  // Keys are built at run time; why.test.ts checks that every reason has one.
  const translate = t as unknown as (key: string, options?: object) => string;
  return translate(`why.${reason}`, params(state, reason));
}

/** The same for a failed attempt kept in the history; files and setups have no reason. */
export function errorText(t: TFunction, state: GameState, error: HistoryError): string {
  if (error.reason) return whyText(t, state, error.reason);
  return error.rule ? t('why.generic', { rule: error.rule }) : error.message;
}
